import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab"]

  connect() {
    this.boundSyncFromFrame = this.syncFromFrame.bind(this)
    this.frame = document.getElementById("roadmap_view")
    this.frame?.addEventListener("turbo:frame-load", this.boundSyncFromFrame)
  }

  disconnect() {
    this.frame?.removeEventListener("turbo:frame-load", this.boundSyncFromFrame)
  }

  activate(event) {
    const view = event.currentTarget.dataset.roadmapTabsViewParam
    if (!view) return

    this.setActive(view)
  }

  syncFromFrame() {
    const src = this.frame?.src || this.frame?.getAttribute("src")
    if (!src) return

    const view = new URL(src, window.location.origin).searchParams.get("view") || "board"
    this.setActive(view)
  }

  setActive(view) {
    this.tabTargets.forEach((tab) => {
      tab.classList.toggle("is-active", tab.dataset.roadmapTabsViewParam === view)
    })
  }
}
